import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import utils from 'helpers/utils';
import Box from 'components/atoms/Layout/Box/Box';

const StyledListWrapper = styled(Box)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--list-wrapper-bounds-top': props.$wrapper?.boundsCum?.top ?? '0px',
      '--list-wrapper-bounds-bottom': props.$wrapper?.boundsCum?.bottom ?? '0px'
    };

    return utils.styleProps(attr, vars);
  })`
  display: flex;
  flex-direction: column;
  height: 100%;
  
  &.ListWrapper {
    &-stickyHeader {
      .ListWrapper {
        &-header {
          position: sticky;
          top: ${props => props.$css.$var('--list-wrapper-bounds-top')};
        }
      }
    }

    &-stickyFooter {
      .ListWrapper {
        &-footer {
          position: sticky;
          bottom: ${props => props.$css.$var('--list-wrapper-bounds-bottom')};
        }
      }
    }
  }
  
  .ListWrapper {
    &-content {
      height: 1px;
      flex-grow: 1;
    }

    &-header, &-footer {
      width: 100%;
      scroll-margin: 0;
      z-index: ${props => props.theme.property('zIndex.appBar')};
    }
  }

  ${ComponentStyles}
`;

StyledListWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledListWrapper;
